
export default {
    namespaced: true,
    state: () => ({
        tableOptions:
        {
            page: 1,
            itemsPerPage : 10,
            sortBy : [ "regdate" ],
            sortDesc : [ true ],
            groupBy : [],
            groupDesc : [],
            multiSort : false,
            mustSort : false
        },
        search: null,
        status: 'Any',
        extendedFilter: {
            RegDateFrom: {
                label: "Дата_регистрации_c",
                value: null
            },
            RegDateTo: {
                label: "Дата_регистрации_по",
                value: null
            },
            /*ValidityFrom: {
                label: "Срок_действия_с",
                value: null
            },
            ValidityTo: {
                label: "Срок_действия_по",
                value: null
            },*/
            PersonCategory: {
                label: "Категория_лица",
                value: []
            }
        }
    }),
    mutations: {
        SET_TABLE_OPTION (state, payload) {
            state.tableOptions = payload;
        },
        SET_TABLE_OPTION_PAGE (state, payload) {
            state.tableOptions.page = payload;
        },
        SET_SEARCH (state, payload) {
            state.search = payload;
        },
        SET_STATUS (state, payload) {
            state.status = payload;
        },
        SET_EXTENDED_FILTER (state, payload) {
            state.extendedFilter = payload;
        },
    },
    getters: {
        getTableOptions: (s) => s.tableOptions,
        getExtendedFilter: (s) => s.extendedFilter,
        getSearch: (s) => s.search,
        getStatus: (s) => s.status,
    }
}